/* Kanela: Scrollposition in Produktlisten merken und beim Zurueckgehen wiederherstellen.
   Funktioniert mit dem NICCOS-KANELA-Filters Raster (Mehr laden) und mit normalen Seiten. */
(function () {
  if (window.__kanelaScrollRestore) return;
  window.__kanelaScrollRestore = true;

  var KEY = 'kanelaScroll:' + location.pathname + location.search;
  var MAX_AGE = 30 * 60 * 1000; // 30 Minuten
  var TIMEOUT = 15000;          // max. 15 Sekunden warten
  var MAX_CLICKS = 25;          // max. 25 x "Mehr laden"

  function app() { return document.querySelector('[data-kanela-filter-app]'); }
  function cardCount() {
    var a = app();
    return a ? a.querySelectorAll('.product-card').length : 0;
  }
  function save() {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ y: window.scrollY, n: cardCount(), t: Date.now() }));
    } catch (e) {}
  }

  // Position merken, sobald ein Produkt angeklickt wird oder die Seite verlassen wird
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('a[href*="/products/"]');
    if (link) save();
  }, true);
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') save(); });

  // Nur beim Zurueck/Vorwaerts-Navigieren wiederherstellen
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  if (nav.type !== 'back_forward') return;

  var state = null;
  try { state = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!state || !state.y || Date.now() - state.t > MAX_AGE) return;

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  var start = Date.now();
  var clicks = 0;
  var userScrolled = false;
  ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, function () { userScrolled = true; }, { once: true, passive: true });
  });

  // Position setzen und einige Sekunden halten, falls die Seite nachtraeglich
  // noch umbaut (Filter-App, Bilder, Bewertungen usw.)
  function finish() {
    if (userScrolled) return;
    var holdUntil = Date.now() + 4000;
    (function hold() {
      if (userScrolled) return;
      var maxY = document.documentElement.scrollHeight - window.innerHeight;
      var target = Math.min(state.y, maxY);
      if (Math.abs(window.scrollY - target) > 5) window.scrollTo(0, target);
      if (Date.now() < holdUntil || target < state.y - 5) {
        if (Date.now() < start + TIMEOUT) setTimeout(hold, 100);
      }
    })();
  }

  function appReady(a) {
    return a.classList.contains('is-ready') &&
      !a.classList.contains('is-loading') &&
      cardCount() > 0;
  }

  function step() {
    if (userScrolled) return;
    if (Date.now() - start > TIMEOUT) return finish();

    var a = app();
    if (!a) {
      // Seite ohne Filter-Raster: warten bis alles geladen ist, dann scrollen
      if (document.readyState === 'complete' || Date.now() - start > 2000) return finish();
      return setTimeout(step, 150);
    }
    if (!appReady(a)) return setTimeout(step, 150);

    if (cardCount() < state.n && clicks < MAX_CLICKS) {
      var btn = a.querySelector('.kanela-filter-app__pagination button');
      if (btn && btn.disabled) return setTimeout(step, 150);
      if (btn && !btn.hidden) {
        clicks++;
        btn.click();
        return setTimeout(step, 250);
      }
    }
    // Bilder kurz Zeit geben, damit die Hoehe stimmt
    setTimeout(finish, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', step);
  } else {
    step();
  }
})();
